import { makeStyles } from "@material-ui/core";
import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";
const useStyles = makeStyles({
    toolbar: {
        display: "flex",
        justifyContent: "space-between",
        "& *:nth-last-child(1)": {
            marginLeft: "auto"
        }
    },
    container: {
        display: "flex",
        flexWrap: "nowrap",
        overflow: "hidden",
        flexDirection: "column",
    },
    view: {
        display: "block",
        flex: "0 0 100%"
    }
});
const variants = {
    enter: (direction) => {
        return {
            x: direction > 0 ? 1000 : -1000,
            opacity: 0
        };
    },
    center: {
        zIndex: 1,
        x: 0,
        opacity: 1
    },
    exit: (direction) => {
        return {
            zIndex: 0,
            x: direction < 0 ? 1000 : -1000,
            opacity: 0
        };
    }
};
export const StackView = ({ prevAction, nextAction, children }) => {
    const classes = useStyles();
    const [[current, direction], setCurrent] = useState([0, 0]);
    const views = typeof children === "function" ? children({}) : children;
    const canStepForward = current < views.length - 1;
    const canStepBackward = current >= 1;
    const prev = () => (canStepBackward ? setCurrent([current - 1, -1]) : false);
    const next = () => (canStepForward ? setCurrent([current + 1, 1]) : false);
    return (React.createElement(React.Fragment, null,
        React.createElement("nav", { className: classes.toolbar },
            prevAction(prev, canStepBackward),
            nextAction(next, canStepForward)),
        React.createElement(AnimatePresence, { initial: false },
            React.createElement("div", { className: classes.container }, React.Children.map(typeof children === "function" ? children({ current, prev, next }) : children, (child, index) => (React.createElement(motion.div, { style: { display: index !== current && "none" }, className: classes.view, key: `index-${current}`, custom: direction, variants: variants, initial: "enter", animate: "center", exit: "exit", transition: {
                    x: { type: "spring", stiffness: 300, damping: 30 },
                    opacity: { duration: 0.2 }
                } }, child)))))));
};
//# sourceMappingURL=StackView.js.map